// src/components/LoadingOverlay.jsx
import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useLoading } from '../context/LoadingContext';

export default function LoadingOverlay() {
  const ctx = useLoading();
  const isLoading = !!ctx?.isLoading;

  if (!isLoading) return null;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.35)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2000
    }}>
      <div className="text-center text-white">
        <Spinner animation="border" role="status" />
        <div className="mt-2">Chargement…</div>
      </div>
    </div>
  );
}
